export var mapNav = function mapNav() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Array.isArray(categories) ? categories.map(function (category) {
    return {
      "navigationTitle": {
        "value": category.DisplayName
      },
      "hideInNavigation": {
        "value": !category.IsActive || ""
      },
      "url": category.CategoryContentPagePath,
      children: mapNav(category.Categories) // TODO - Will need to build out below but unsure of how
      // navigationText
      // navigationImage
      // navigationLink
      // navigationSubtitle

    };
  }) : [];
};